import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { assert_string_uuid } from '@shared/asserts/utils_asserts_string';
import { Node, NodeChange } from '@xyflow/react';

export function FN_GRAPH_UPDATE__node_select__by_change(change: NodeChange<Node>) {
  if (change.type !== 'select') return false;
  if (!change.selected) return false;

  let id = change.id;

  assert_string_uuid(id);

  UTILS__graph_ui.node__select(id);

  return false; //no need to update graph remotely
}
